import React, { Fragment } from "react";
import $ from "jquery";
import { Row, Col, Form } from "react-bootstrap";
import LocationsDropdown from "../dropdowns/LocationsDropdown";
import ClassLevelsDropdown from "../dropdowns/ClassLevelsDropdown";
import ClassTypesDropdown from "../dropdowns/ClassTypesDropdown";
import InstructorsDropdown from "../dropdowns/InstructorsDropdown";
import { useTranslation } from "react-i18next";
import { Checkbox } from "semantic-ui-react";

const ClassTemplate = (props) => {
    const { t } = useTranslation();
    const { template, blockForm, setTemplate, setFormChanged } = props;
    return (
        <Fragment>
            <Row>
                <Col xs={12} lg={7} xl={5}>
                    <Form.Group controlId={"className"} className="mb-3">
                        <Form.Label>
                            {t("templates.className")} <span className="req">*</span>
                        </Form.Label>
                        <p className="text-small mb-2">{t("templates.classNameHelper")}</p>
                        <Form.Control
                            value={template.class_name}
                            onChange={(e) => {
                                setTemplate({ ...template, class_name: e.target.value });
                                $("#className").removeClass("is-invalid");
                                setFormChanged(true);
                            }}
                            placeholder={t("templates.typeClassName")}
                            disabled={blockForm}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={6} lg={3}>
                    <Form.Group controlId={"classSlots"} className="mb-3 mt-lg-0">
                        <Form.Label>
                            {t("templates.classSlots")} <span className="req">*</span>
                        </Form.Label>
                        <Form.Control
                            value={template.class_slots}
                            onChange={(e) => {
                                setTemplate({ ...template, class_slots: e.target.value });
                                $("#classSlots").removeClass("is-invalid");
                                setFormChanged(true);
                            }}
                            placeholder={t("typeNumber")}
                            disabled={blockForm}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6} lg={4}>
                    <Form.Group controlId={"classDuration"} className="mb-3">
                        <Form.Label>
                            {t("templates.classDuration")} <span className="req">*</span>
                        </Form.Label>
                        <Form.Control
                            value={template.class_duration}
                            onChange={(e) => {
                                setTemplate({ ...template, class_duration: e.target.value });
                                $("#classDuration").removeClass("is-invalid");
                                setFormChanged(true);
                            }}
                            placeholder={t("typeNumber")}
                            disabled={blockForm}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={4}>
                    <ClassLevelsDropdown
                        req
                        id="classLevelsDropdown"
                        value={template.class_level_code}
                        onChange={(v) => {
                            setTemplate({ ...template, class_level_code: v });
                            $("#classLevelsDropdown").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        disabled={blockForm}
                    />
                </Col>
                <Col xs={12} lg={3}>
                    <ClassTypesDropdown
                        req
                        id="classTypesDropdown"
                        value={template.class_type_code}
                        onChange={(v) => {
                            setTemplate({ ...template, class_type_code: v });
                            $("#classTypesDropdown").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        disabled={blockForm}
                    />
                </Col>
                <Col xs={12} lg={5}>
                    <LocationsDropdown
                        req
                        id="classLocationsDropdown"
                        value={template.location_id}
                        onChange={(v) => {
                            setTemplate({ ...template, location_id: v });
                            $("#classLocationsDropdown").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        disabled={blockForm}
                    />
                </Col>
                <Col xs={12} lg={6}>
                    <InstructorsDropdown
                        req
                        label
                        id="classInstructorDropdown"
                        value={template.instructor_user_id}
                        onChange={(v) => {
                            setTemplate({ ...template, instructor_user_id: v });
                            $("#classInstructorDropdown").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        disabled={blockForm}
                        helper
                        allowAddNewInstr
                    />
                </Col>
                <Col xs={12} lg={6}>
                    <Form.Group className="mb-3" controlId={`classInstructorLabel`}>
                        <Form.Label className="w-100">{t(`classes.classGuest`)}</Form.Label>
                        <p className="text-small mb-2">{t("classes.classGuestHelper")}</p>
                        <Form.Control
                            value={template.instructor_label}
                            onChange={(el) => {
                                setTemplate({ ...template, instructor_label: el.target.value });
                                $("#classInstructorLabel").removeClass("is-invalid");
                                setFormChanged(true);
                            }}
                            placeholder={t(`classes.classGuestPlaceholder`)}
                            disabled={blockForm}
                        />
                    </Form.Group>
                </Col>
                <Col xs={12} lg={7}>
                    <Form.Group className="mb-3" controlId={`classDescription`}>
                        <Form.Label className="w-100">
                            {t(`classes.classDescription`)} <span className="req">*</span>
                        </Form.Label>
                        <Form.Control
                            value={template.class_descr}
                            onChange={(el) => {
                                setTemplate({ ...template, class_descr: el.target.value });
                                $("#classDescription").removeClass("is-invalid");
                                setFormChanged(true);
                            }}
                            placeholder={t(`classes.classDescriptionPlaceholder`)}
                            as="textarea"
                            disabled={blockForm}
                        />
                    </Form.Group>
                </Col>
                <Col xs={12} lg={5}>
                    <Form.Group className="mb-3" controlId={`earlyCancelAvailability`}>
                        <Form.Label className="w-100">{t(`classes.earlyCancel`)}</Form.Label>
                        <Checkbox
                            toggle
                            label={t("classes.earlyCancelAvailability")}
                            checked={template.early_cancel_available}
                            disabled={blockForm}
                            onChange={() => {
                                setTemplate({ ...template, early_cancel_available: !template.early_cancel_available });
                                $("#earlyCancelAvailability").removeClass("is-invalid");
                                setFormChanged(true);
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ClassTemplate;
